export const EVENTS = {
  REWARDS: {
    LOAD: 'rewards.load',
    LOADED: 'rewards.loaded',
    LOAD_ERROR: 'rewards.load_error',
    LOAD_LEVELS: 'rewards.load_levels',
    LEVELS_LOADED: 'rewards.levels_loaded',
    LOAD_RULES: 'rewards.load_rules',
    RULES_LOADED: 'rewards.rules_loaded',
    LOAD_MILESTONES: 'rewards.load_milestones',
    MILESTONES_LOADED: 'rewards.milestones_loaded',
    CLAIM: 'rewards.claim',
    CLAIMED: 'rewards.claimed',
    NOT_CLAIMED: 'rewards.not_claimed',
    CLAIM_REQUESTED: 'rewards.claim_requested',
    DETAIL_REQUIRED: 'rewards.detail_required',
    SHOW_DETAIL: 'rewards.show_detail',
    START: 'rewards.start',
    LEVEL_DATA_AVAILABLE: 'rewards.level_data_available',
    LEVEL_UPDATED: 'rewards.level_updated',
    FETCH_USER_LEVEL: 'rewards.fetch_user_level',
    FETCH_PROFILE: 'rewards.fetch_profile',
    PROFILE_LOADED: 'rewards.profile_loaded'
  }
};

export const ENDPOINTS = {
  REWARDS: {
    PROFILE_CREATE: 'https://api.monrapidoo.com/reward/profile?group=ultraxeno',
    PROFILE_GET: 'https://api.monrapidoo.com/reward/profile/:userId?group=ultraxeno',
    PROFILE_PROGRESS: 'https://api.monrapidoo.com/reward/profile/progress/:userId?group=ultraxeno',
    PROFILE_MILESTONES: 'https://api.monrapidoo.com/reward/profile/milestone/:userId?group=ultraxeno',
    LEVELS: 'https://api.monrapidoo.com/reward/levels?group=ultraxeno',
    MILESTONE_CLAIM: 'https://api.monrapidoo.com/reward/profile/:userId/milestone/:milestoneId/claim?group=ultraxeno',
    RULES: 'https://api.monrapidoo.com/reward/rules?group=ultraxeno'
  }
};
